<template>
  <div class="sugerido--compra">
    <vuestic-widget header-text="Sugerido de Compra">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <sucursal />
            <proveedor @changeProvider="changeProvider"/>
            <categoria />
            <codigo />
            <descripcion />
            <grupo />
          </div>
        </div>
      </div>
      <spinner v-if="isLoading" text="Cargando sugerido compra..." />
      <tabla-sugerido-compra v-else :currentProvider="currentProvider"/>
    </vuestic-widget>
  </div>
</template>

<script>
import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
import Proveedor from "../component/selectCompras/Proveedor";
import Categoria from "../component/selectCompras/Categoria";
import Codigo from "../component/selectCompras/Codigo";
import Grupo from "../component/selectCompras/Grupo";
import TablaSugeridoCompra from "../component/Tablas/tablaSugeridoCompra";
import Spinner from "../../Componentes_Globales/Spinner/Spinner";
import Sucursal from "../component/selectCompras/Sucursal";
import SugeridoCompraCarro from "../component/SugeridoCompraCarro";
import { mapGetters } from "vuex";
import Descripcion from "../component/selectCompras/Descripcion";
//mis tests
import makeQuery from "../../../api/helper";

export default {
  name: "sugeridoCompra",
  components: {
    Descripcion,
    SugeridoCompraCarro,
    Sucursal,
    Spinner,
    TablaSugeridoCompra,
    Categoria,
    Proveedor,
    VuesticWidget,
    Codigo,
    Grupo
  },
  data() {
    return {
      filtros: {},
      loading: false,
      currentProvider: undefined
    };
  },
  beforeCreate() {
    this.$store.dispatch("sugeridoCompra/getProductosSugerido");
  },
  methods: {
    changeProvider({ id }) {
      this.currentProvider = id
    }
  },
  computed: {
    ...mapGetters({
      isLoading: "sugeridoCompra/isLoading"
    })
  },
};
//Mis Tests
</script>

<style scoped>
.input-group {
  margin-right: 10px;
}
</style>
